export interface SearchFilters {
  query_search: string;
  is_launch: string;
  is_sale: string;
  is_rent: string;
  id_category: string;
  id_empreendimento: string;
  id_constructor: string;
  address_city: string[];
  address_district: string[];
  address_street: string;
  address_zone: string[];
  min_sale_price: number;
  max_sale_price: number;
  min_rent_price: number;
  max_rent_price: number;
  min_taxas: number;
  max_taxas: number;
  id_type: string[];
  min_area: number;
  max_area: number;
  qtd_rooms: string[];
  qtd_bathrooms: string[];
  qtd_suite: string[];
  qtd_parking: string[];
  is_mobiliado: string;
  order_by: string;
  order_type: 'asc' | 'desc';
}

export const DEFAULT_SEARCH_FILTERS: SearchFilters = {
  query_search: '',
  is_launch: '',
  is_sale: '',
  is_rent: '',
  id_category: '',
  id_empreendimento: '',
  id_constructor: '',
  address_city: [],
  address_district: [],
  address_street: '',
  address_zone: [],
  min_sale_price: 0,
  max_sale_price: 3000000,
  min_rent_price: 0,
  max_rent_price: 10000,
  min_taxas: 0,
  max_taxas: 1000000,
  id_type: [],
  min_area: 0,
  max_area: 10000,
  qtd_rooms: [],
  qtd_bathrooms: [],
  qtd_suite: [],
  qtd_parking: [],
  is_mobiliado: '',
  order_by: '0',
  order_type: 'desc',
};

export const QTY_OPTIONS = ['1', '2', '3', '4', '5', '6+'] as const;
